<template>
    <div class="col-lg-12">
        <div class="ibox form">
            <div class="ibox-content">
                <div class="row">
                    <div class="col-auto">
                        <h1>
                            {{ __("instance_being_created_please_wait") }}
                        </h1>
                    </div>
                    <div class="col-auto">
                        <div class="spiner-example spinner-client">
                            <div class="sk-spinner sk-spinner-fading-circle">
                                <div class="sk-circle1 sk-circle"></div>
                                <div class="sk-circle2 sk-circle"></div>
                                <div class="sk-circle3 sk-circle"></div>
                                <div class="sk-circle4 sk-circle"></div>
                                <div class="sk-circle5 sk-circle"></div>
                                <div class="sk-circle6 sk-circle"></div>
                                <div class="sk-circle7 sk-circle"></div>
                                <div class="sk-circle8 sk-circle"></div>
                                <div class="sk-circle9 sk-circle"></div>
                                <div class="sk-circle10 sk-circle"></div>
                                <div class="sk-circle11 sk-circle"></div>
                                <div class="sk-circle12 sk-circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ibox form">
                <div class="ibox-content">
                    <div class="row">
                        <div class="col-sm-4 col-sm-offset-2">
                            <a
                                :href="clitentListRoute"
                                class="btn btn-white btn-sm"
                                >{{ __("go_to_the_list_of_clients") }}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import actions from "./../../vuex/client_form/action_types.js";

export default {
    props: {
        clitentListRoute: {
            type: String,
            default: "#"
        },
        clientId: {
            default: 0
        }
    },
    methods: {
        checkClientIsReady() {
            this.$store
                .dispatch(actions.CHECK_CLIENT_IS_READY, this.clientId)
                .then(response => {
                    if (response.data.ready) {
                        location.reload();
                    }
                });
        }
    },
    mounted() {
        this.checkClientIsReady();
        setInterval(() => {
            this.checkClientIsReady();
        }, 5000);
    }
};
</script>

<style lang="scss" scoped>
.spinner-client {
    padding-top: 12px;
    height: 40px;
}
</style>
